import React, {useEffect} from "react";
import FormErrorList from "./FormErrorList";

const FormErrorNotification = (props) => {

    if (!props.errors || !Object.keys(props.errors).length) {
        return null;
    }

    return (
        <div className="section form-container full">
            <div className="callout errors margin-bottom-2">
                <div className="callout-inner">
                    <h4>
                        <i className="fa fa-warning"/>&nbsp;&nbsp;
                        Oops! Something went wrong on the form.
                    </h4>
                    <ul>
                        <FormErrorList errors={props.errors}/>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default FormErrorNotification;
